import React from 'react';

import { Layout, Col } from 'antd';
import HeaderDefault from '../Header';

interface WrapperProps {
  style?: React.CSSProperties;
  className?: string;
  children?: React.ReactNode;
  header?: boolean;
}

const Wrapper: React.FC<WrapperProps> = (props) => {
  const { children, header = false } = props;

  return (
    <Layout>
      <Col className="container">
        {header && <HeaderDefault />}
        {children}
      </Col>
    </Layout>
  );
};

export default Wrapper;
